<template>
    <div>
        <q-table
            :data="materials"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            >
            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="secondary" :disable="statusBtn || appointment_status === 9 && !manage_models" icon="far fa-plus" :label="$t('new')" @click="showMaterialModal(0)" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="extension" :props="props">
                    {{ props.row.extension }}
                </q-td>

                <q-td key="size" :props="props">
                    {{ props.row.size }}
                </q-td>

                <q-td auto-width key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td auto-width key="show_student" :props="props">
                    <q-chip small :icon="getIconPermission(props.row.show_student)" :color="getColorPermission(props.row.show_student)" class="full-width">
                        {{ $t(getPermission(props.row.show_student)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn :disable="statusBtn || appointment_status === 9 && !manage_models" flat round color="primary" icon="far fa-pencil-alt" @click="showMaterialModal(props.row.actions)" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip') }}
                        </q-tooltip>
                    </q-btn>

                    <q-btn :disable="statusBtn || appointment_status === 9 && !manage_models" flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" >
                        <q-tooltip>
                            {{ $t('delete_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-modal v-model="material_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="clearMaterialModal()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="material_modal = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('support_material') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">

                        <div class="col-xs-12 col-sm-12">
                            <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <p class="caption">{{ $t('status') }}</p>
                            <q-btn-toggle v-model="status" :toggle-color="getColorButtonStatus" :options="statuses" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <p class="caption">{{ $t('permission') }}</p>
                            <q-btn-toggle v-model="show_student" :toggle-color="getColorButtonPermission" :options="permissons" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <p class="caption">{{ $t('file') }}</p>
                            <uploader content_type="" @fileUploaded="fileUploaded" :multiple="false" :cropper="false" :error="$v.file_url.$error" @input="$v.file_url.$touch" />

                            <p v-if="file_url" class="q-mt-md file-url">
                                <q-icon name="fal fa-check" color="positive" />
                                <a :href="file_complete_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                            </p>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-block" @click="material_modal = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveMaterial()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_remove" @ok="removeMaterial()">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeMaterial()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "training", "admin"]},

    name: 'AdminPresentialSupportMaterials',

    props: ['appointment_status', 'manage_models' ],

    data() {
        return {
            presential_event_id: '',
            id_material: '',
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            materials: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'material',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'extension',
                    required: true,
                    label: 'extension',
                    align: 'left',
                    field: 'extension',
                    sortable: false,
                },
                {
                    name: 'size',
                    required: true,
                    label: 'size',
                    align: 'left',
                    field: 'size',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },

                {
                    name: 'show_student',
                    required: true,
                    label: 'permission',
                    align: 'left',
                    field: 'show_student',
                    sortable: false,
                },

                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            loading: false,
            confirm_remove: false,
            action_id: '',
            material_modal: false,
            title: '',
            status: 1,
            statuses: [
                { label: this.$t('published'), value: 1 },
                { label: this.$t('unpublished'), value: 2 }
            ],
            permissons: [
                { label: this.$t('public'), value: 1 },
                { label: this.$t('private'), value: 0 }
            ],
            show_student:1,
            file_url: '',
            file_complete_url: ''
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getColorButtonStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        getColorButtonPermission() {
            if (this.show_student == 1) return 'positive'
            else return 'negative'
        },

        statusBtn() {
            if(this.appointment_status == 8) return true
            else return false
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`/presential/presential_events/${this.presential_event_id}/support_materials/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.materials = []
                response.data.forEach(result => {
                    this.materials.push({
                        id: result.id,
                        title: result.title,
                        extension: result.extension,
                        size: result.size,
                        status: result.status,
                        show_student: result.show_student ? 1 : 0,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fileUploaded(url) {
            this.file_url = url
            this.file_complete_url = url
        },

        showMaterialModal(id) {
            if (id != 0) {
                this.id_material = id
                this.$q.loading.show()

                this.$axios.get(`/presential/presential_events/${this.presential_event_id}/support_materials/${this.id_material}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.status = response.data.status
                    this.file_url = response.data.resource
                    this.file_complete_url = response.data.resource_url

                    this.$q.loading.hide()
                    this.material_modal = true
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.id_material = 0
                this.material_modal = true
            }
        },

        saveMaterial() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()
                let data = {
                    title:this.title,
                    status:this.status,
                    show_student:this.show_student,
                    resource:this.file_url
                }

                if (this.id_material != 0) {
                    this.$axios.put(`/presential/presential_events/${this.presential_event_id}/support_materials/${this.id_material}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.material_modal = false
                        this.request({
                            pagination: this.server_pagination
                        })

                        this.$q.notify({
                            message: this.$t('support_material_edit_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('support_material_edit_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/presential/presential_events/${this.presential_event_id}/support_materials/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.material_modal = false
                        this.request({
                            pagination: this.server_pagination
                        })

                        this.$q.notify({
                            message: this.$t('support_material_add_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('support_material_add_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeMaterial() {
            this.$q.loading.show()

            this.$axios.delete(`/presential/presential_events/${this.presential_event_id}/support_materials/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getPermission(status) {
            if (status == 1) return 'public'
            else return 'private'
        },

        getColorPermission(status) {
            if (status == 1) return 'positive'
            else return 'negative'
        },

        getIconPermission(status) {
            if (status == 1) return 'fas fa-eye'
            else return 'fas fa-eye-slash'
        },

        clearMaterialModal() {
            this.title = ''
            this.status = 1
            this.file_url = ''
            this.$v.$reset()
        }
    },

    created() {
        this.presential_event_id = this.$route.params.id

        this.request({
            pagination: this.server_pagination
        })
    },

    validations() {
        return {
            title: { required },
            file_url: { required }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
